import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { phoneNumberProp } from '@/features/account-management/screens/details/hooks/useCard.hook';

export interface CardDetailModalProps {
  onLayout?: (event: any) => void;
}

export enum CardDetailStackRoutes {
  Main = 'main',
  DailyLimitTypes = 'dailyLimitTypes'
}

export type CardDetailStackParamList = {
  [CardDetailStackRoutes.Main]: CardDetailModalProps & {
    account: string;
    tab?: number;
    record: any;
    funcLockCard?: (cardId: string, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    funcUnlockCard?: (cardId: string, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    funcSetCardLimit?: (
      cardId: string,
      atmLimit?: number,
      purchaseLimit?: number,
      onSuccess?: (data: any) => void,
      onError?: (error: any) => void
    ) => void;
    funcChangeCardPin?: (cardId: string, pin: string, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    refresh?: () => void;
    funcTopUpCardAccount?: (
      accountId: string,
      amount: number,
      currency: string,
      onSuccess?: (data: any) => void,
      onError?: (error: any) => void
    ) => void;
    funcActivateCard?: (cardId: string, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    funcCancelCard?: (data: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    funcSuspendCard?: (cardId: string, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    funcUnsuspendCard?: (cardId: string, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    funcUpdateCardPhoneNumberCard?: (
      cardId: string,
      phoneNumber: phoneNumberProp,
      onSuccess?: (data: any) => void,
      onError?: (error: any) => void
    ) => void;
  };
  [CardDetailStackRoutes.DailyLimitTypes]: CardDetailModalProps;
};

export type CardDetailStackScreenProps<Screen extends keyof CardDetailStackParamList> = NativeStackScreenProps<
  CardDetailStackParamList,
  Screen
>;

export enum AccountDetailsTabRoutes {
  Account = 'account-details-account',
  Card = 'account-details-card'
}

export type AccountDetailsTabParamList = {
  [AccountDetailsTabRoutes.Account]: {
    account: string;
    tab?: number;
    record: any;
    flag?: string;
  };
  [AccountDetailsTabRoutes.Card]: {
    account: string;
    tab?: number;
    record: any;
    flag?: string;
    options?: { [key: string]: any };
  };
};

export type AccountDetailsTabScreenProps<Screen extends keyof AccountDetailsTabParamList> = NativeStackScreenProps<
  AccountDetailsTabParamList,
  Screen
>;
